import { Form, InputNumber, Select } from 'antd';

import { ACADEMY_POINTS_MAX, ACADEMY_POINTS_MIN, DOMAINS } from './academy';

/**
 * Área e pontos da Academia da Mente. Só renderiza em edição de Treinamento: invisível,
 * os campos nem entram no form (não bloqueiam o salvar).
 */
export const AcademyFields: React.FC<{ visible: boolean }> = ({ visible }) => {
  if (!visible) return null;
  return (
    <>
      <Form.Item
        name="cognitiveDomain"
        label="Área"
        rules={[{ required: true, message: 'Informe a área.' }]}
      >
        <Select style={{ width: 200 }} placeholder="Escolha a área">
          {DOMAINS.map((d) => (
            <Select.Option key={d.value} value={d.value}>
              <span
                style={{
                  display: 'inline-block',
                  width: 10,
                  height: 10,
                  borderRadius: '50%',
                  background: d.color,
                  marginRight: 8,
                }}
              />
              {d.label}
            </Select.Option>
          ))}
        </Select>
      </Form.Item>
      <Form.Item
        name="academyPoints"
        label="Pontos da Academia"
        rules={[{ required: true, message: 'Informe os pontos.' }]}
      >
        <InputNumber precision={0} style={{ width: 160 }} min={ACADEMY_POINTS_MIN} max={ACADEMY_POINTS_MAX} />
      </Form.Item>
    </>
  );
};

export default AcademyFields;
